<template>
  <div>
    <Navbar appTitle="申请领料" />
    <div class="search-content wrap-apply" :style="{top: GLOBAL.currentEnvironment ? '0' : '',height: GLOBAL.currentEnvironment ? '100vh' : 'calc(100vh - 1.12rem)',paddingBottom: GLOBAL.currentEnvironment ? '1rem' : ''}">
      <van-cell-group style="margin-top: 0.1rem">
        <p class="label required FormTit"><span></span>工单编号</p>
        <!-- <van-field v-model="buildForm.orderCode" placeholder="请输入" /> -->
        <scanInput
          ref="scanInput"
          :key="index"
          :columns="columns"
          @changeScan="changeScan"
        />
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <p class="label FormTit"><span></span>生产物料</p>
        <van-field
          readonly
          v-model="goodsFullName"
          placeholder="请选择工单编号"
        />
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <p class="label FormTit"><span></span>基本单位</p>
        <van-field
          readonly
          v-model="buildForm.goodsBasicUnitText"
          placeholder="请选择工单编号"
        />
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <p class="label required FormTit"><span></span>领料人</p>
        <van-field
          is-link
          readonly
          name="picker"
          v-model="createdByName"
          @click="ddthrVisible = true"
          placeholder="请选择"
          :rules="[{ required: true, message: '请选择领料人' }]"
        >
        </van-field>
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <p class="label FormTit"><span></span>领用时间</p>
        <van-field
          is-link
          readonly
          name="picker"
          v-model="buildForm.receiveTime"
          @click="receiveTimeModal = true"
          placeholder="请选择"
        >
          <template slot="right-icon" v-if="buildForm.receiveTime">
            <img
              src="~@/assets/img/filedClear.png"
              alt=""
              @click.stop="clickClose"
              style="width: 0.16rem; height: 0.16rem"
            />
          </template>
        </van-field>
      </van-cell-group>

      <van-cell-group style="margin-top: 0.1rem">
        <div class="label otherText">
          <div style="display: inline-block">
            <img
              @click="changeItem(true)"
              v-if="checkboxList.length == 0"
              style="width: 0.2rem; height: 0.2rem; margin-top: -0.05rem"
              src="../../../assets/btna.png"
              alt=""
            />
            <img
              @click="changeItem(true)"
              v-if="
                checkboxList.length !== 0 &&
                checkboxList.length !== goodsList.length
              "
              style="width: 0.22rem; height: 0.22rem; margin-top: -0.05rem"
              src="../../../assets/btnb.png"
              alt=""
            />
            <!-- 勾选 -->
            <img
              @click="changeItem(false)"
              v-if="
                checkboxList.length !== 0 &&
                checkboxList.length === goodsList.length
              "
              style="width: 0.22rem; height: 0.22rem; margin-top: -0.05rem"
              src="../../../assets/btnc.png"
              alt=""
            />
          </div>
          <span class="goodsTitleOne">领用物料</span>
        </div>
        <div class="bottomLine"></div>

        <van-checkbox-group
          v-model="checkboxList"
          ref="checkboxGroup"
          direction="horizontal"
          @change="changeCheckValue"
        >
          <div class="checkF">
            <van-checkbox
              v-for="(item, index) in goodsList"
              :key="index"
              class="wrap"
              :name="item"
              shape="square"
              :label-disabled="true"
            >
              <p class="goodsTitle">
                {{ item.goodsCode }}-{{ item.goodsName }}
              </p>
              <p class="goodsCell">
                <span class="goodsLabel">物料规格：</span>{{ item.goodsSpec }}
                {{ item.goodsBasicUnitText }}
              </p>
              <p class="goodsCell">
                <span class="goodsLabel">计划投料：</span
                >{{ item.planTotalNum }} {{ item.goodsBasicUnitText }}
              </p>
              <p class="goodsCell">
                <span class="goodsLabel">已领量：</span>{{ item.receivedNum }}
                {{ item.goodsBasicUnitText }}
              </p>
              <p class="goodsCell">
                <span class="goodsLabel">在申领量：</span
                >{{ item.lockNum || "0" }} {{ item.goodsBasicUnitText }}
              </p>
              <van-cell-group>
                <van-field
                  width="100%"
                  v-model="item.num"
                  @input="changeNum(item)"
                  placeholder="请输入本次领料量"
                >
                  <template #right-icon>
                    {{ item.goodsBasicUnitText }}
                  </template>
                </van-field>
                <div class="bottomLine"></div>
              </van-cell-group>
            </van-checkbox>
          </div>
        </van-checkbox-group>
      </van-cell-group>

      <van-cell-group style="margin-top: 0.1rem">
        <p class="label otherText">其他</p>
        <div class="bottomLine"></div>
        <p class="label">备注</p>
        <van-field
          v-model="buildForm.remark"
          rows="2"
          autosize
          label=""
          type="textarea"
          maxlength="50"
          placeholder="请输入备注"
          show-word-limit
        />
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <!-- <upload
          :key="index"
          iconType="fj"
          @fileChange="fileChange"
          :fileIds="attachment"
        /> -->
        <fileSelector
          iconType="fj"
          :title="'附件'"
          @fileChange="fileChange"
          :fileIds="attachment"
        ></fileSelector>
      </van-cell-group>
      <div style="margin-top: 0.1rem">
        <Examine
          type="0"
          ref="Examine"
          @submitProcess="submitProcess"
          id="MESS_RECEIVE_MATERIAL_APPLY"
          :key="index"
        />
      </div>
      
      <!--领用时间 -->
      <van-popup v-model="receiveTimeModal" position="bottom">
        <van-datetime-picker
          v-model="nowTime"
          @confirm="confirmReceiveTime"
          @cancel="cancelReceiveTime"
          type="date"
          title="领用时间"
          :formatter="formatter"
        />
      </van-popup>
      <div class="search-bottoms">
        <!-- <span class="btncancel" @click="btnCancel">重置</span> -->
        <span class="btnconfirm" @click="submitProcess">确定</span>
      </div>
    </div>
    <contact-pickers
      :key="index"
      :visible="ddthrVisible"
      @confirm="confirmDdtjr"
      @closePicker="closePicker"
      :max="1"
    >
    </contact-pickers>
    
  </div>
</template>
<script>
import Navbar from "@/components/navBar/navBar_right";
import scanInput from "@/components/scanCode/scanInput";
import ContactPickers from "@/components/choiceuse/ContactPickers";
import upload from "@/components/upload/upload";
import VanFieldSelectPicker from "@/components/ActionSheet/VanFieldSelectPicker";
import { getOrderCodeDict } from "@/api/mobile";
import { clearNoNum, accAdd, accSub } from "@/utils/util";
import moment from "moment";
import Examine from "@/components/examine";
import { APILX } from "@/api/requestLx";
import fileSelector from "@/components/fileSelector.vue";
export default {
  name: "materialRequisitionForm", //领料单
  components: {
    ContactPickers,
    upload,
    VanFieldSelectPicker,
    Navbar,
    scanInput,
    Examine,
    fileSelector
  },

  data() {
    return {
      goodsFullName: "", //生产物料
      index: "",
      attachment: "", //附件
      goodsList: [],
      checkboxList: [], //列表选中的数据
      checkboxData: [], //列表数据
      orderList: [], //工单列表
      //领用时间
      receiveTimeModal: false,
      nowTime: new Date(),
      buildForm: {
        orderId: "",
        receiveTime: "",
        goodsName: "",
        goodsBasicUnitText: "",
        reciverId: "",
        remark: "",
      },
      createdByName: "", //操作人
      ddthrVisible: false,
      columns: [],
      timeSS: "",
    };
  },
  // 路由返回时先判断当前页是否存在弹窗，有就先关闭弹窗不返回，直到所有弹窗关闭再返回
  beforeRouteLeave(to, from, next) {
    let that = this;
    switch (true) {
      // that.showSearchTag是当前页的筛选弹窗，that.$refs.SearchTag.ddthrVisible是子组件筛选弹窗内的其他弹窗例如人员选择
      case that.ddthrVisible:
        that.ddthrVisible = false;
        next(false);
        break;
      case !that.ddthrVisible:
        next();
        break;
    }
  },
  computed: {},
  mounted() {},
  created() {
    this.getOrderList();
    this.getDetail()
  },
  methods: {
    clickClose() {
      this.buildForm.receiveTime = "";
      this.timeSS = "";
    },
    //   input事件
    changeNum(item) {
       item.num = clearNoNum(item.num);
      // let quantity = Number(item.planTotalNum) - Number(item.receivedNum) - Number(item.lockNum) + Number(item.returnNum)
      if (item.num > item.canNum) {
        item.num = item.canNum;
      }
    },
    getDetail() {
      console.log(this.$route.query.orderId, "this.$route.query.orderId");
      if (this.$route.query.orderId) {
        this.getMaterial( this.$route.query.orderId , "scan");
      }
    },
    indexChange() {
      this.index += 1;
    },
    fileChange(ids) {
      this.attachment = ids;
      console.log("父组件" + ids); //你要保存的fileids
    },
    changeCheckValue(v) {
      console.log(v, "0..0.0.0.");
      this.checkboxData.push(v);
      if (v.length === this.columns.length) {
      } else {
      }
    },
    // 控制全选、清空
    changeItem(v) {
      console.log(v, "aaaitem");
      this.$refs.checkboxGroup.toggleAll(v);
    },
    getOrderList() {
      APILX.productOrderList({
        pageSize: "999",
        statusListStr: "notStarted,inProduction",
      }).then((res) => {
        if (res.code == 200) {
          this.orderList = res.result.records;
          console.log(this.orderList, "工单列表");
          //   筛选出orderList里面的id和orderCode到columns里面
          this.columns = this.orderList.map((item) => {
            return {
              key: item.orderCode,
              value: item.id,
            };
          });
          this.getDetail();
        }
      });
    },
    changeScan(v, opratorType) {
      console.log(v, opratorType, "获取扫码组件数据");
      if (opratorType == "select") {
        console.log(v, "选择的值 进select");
        this.getMaterial(v.value, opratorType);
      }
      //value是下拉选择后值,code是扫码获得的值，根据qrcode判断是否隐藏当前页面只显示相机页
      if (opratorType == "scan") {
        console.log(v, "扫码的值 进scan");
        if (v.code.EntityType != 'workOrder') {
          this.$toast('请扫正确二维码')
          return
        }
        this.getMaterial(v.code.id, opratorType);
      } else {
        //关闭了扫码
        // v.code为扫码的结果值
      }
    },

    // 获取物料
    getMaterial(v, opratorType) {
      if (!v) {
        return;
      }
      this.buildForm.orderId = v;
      let order = this.orderList.find((item) => item.id == v);
      console.log(order, "order");
      this.buildForm.goodsBasicUnitText = order.goodsBasicUnitText;
      this.buildForm.goodsName = order.goodsName;
      this.goodsFullName = `${order.goodsCode}-${order.goodsName}`;
      if (opratorType == "scan") {
        let scanObj = {
          id: order.orderId,
          orderCode: order.orderCode,
        };
        this.$refs.scanInput.propValue(scanObj);
      }

      APILX.messReceiveMaterialApplyQueryByOrderId({ orderId: v }).then(
        (res) => {
          if (res.result) {
            let goodsList = res.result;
            goodsList.forEach((item) => {
              item.num =
                Number(item.planTotalNum) -
                Number(item.receivedNum) -
                Number(item.lockNum);
            });
            this.goodsList = goodsList;
            console.log(this.goodsList, "获取物料详情");
          }
        }
      );
      // console.log(order);
    },
    // 选人
    confirmDdtjr(val, selectedList, judge) {
      this.buildForm.reciverId = "";
      this.createdByName = "";
      if (judge) {
        this.ddthrVisible = false;
        return;
      }
      this.buildForm.reciverId = val ? val : ""; //人员id
      let arr = [];
      if (selectedList) {
        selectedList.forEach((item) => {
          arr.push(item.realname);
        });
      }
      this.createdByName = arr.join(",");
      this.ddthrVisible = false;
    },
    // 关闭选人组件
    closePicker() {
      this.ddthrVisible = false;
    },
    // 重置
    btnCancel() {
      //   this.$refs.topSearch.value = "";
      this.buildForm = {
        receiveTime: null, //领用时间展示
        goodsName: null,
        goodsBasicUnitText: null,
        reciverId: null,
        remark: null,
        orderId: null,
      };
      this.nowTime = new Date(); //滑动了的时间重置
      this.timeSS = ""; //领用时间
      this.goodsList = []; //物料
      this.checkboxList = []; //选择的物料
      (this.attachment = null),
        (this.createdByName = null), //选人展示
        this.indexChange(); //扫码组件重置
    },
    // 获取流程数据
    submitProcess(e) {
      console.log(this.buildForm.orderId, "this.buildForm");

      if (!this.buildForm.orderId) {
        this.$toast("请选择工单编号");
        return;
      }
      if (!this.buildForm.reciverId) {
        this.$toast("请选择领料人");
        return;
      }
      if (this.checkboxList == 0) {
        this.$toast("请选择物料");
        return;
      }
      console.log(e, "eee");
      if (e.nodeDtos) {
        console.log(e);
        this.btnConfirm(e);
      } else {
        this.$refs.Examine.confirm();
      }
    },
    // 表单提交
    btnConfirm(processDataVo) {
      let params = {
        ...this.buildForm,
        messPlanMaterialApplyDtoList: this.checkboxList,
        attachment: this.attachment,
        processDataVo: processDataVo,
      };
      params.receiveTime = this.timeSS;
      APILX.messReceiveMaterialApplyAdd(params).then((res) => {
        if (res.code == 200) {
          this.$toast(res.message);
          //   返回上一级
          this.$router.go(-1);
        } else {
          this.$toast(res.message);
        }
      });
      console.log(params, "sureObjsureObjsureObj");
    },

    // 选择时间
    confirmReceiveTime(date) {
      this.buildForm.receiveTime = moment(date).format("YYYY-MM-DD");
      this.timeSS = moment(date).format("YYYY-MM-DD HH:mm:ss");
      this.receiveTimeModal = false;
    },
    // 取消选择时间
    cancelReceiveTime() {
      this.receiveTimeModal = false;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      if (type === "hour") {
        return val + "时";
      }
      if (type === "minute") {
        return val + "分";
      }
      return val;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/theme.scss";
@import "@/views/workManagement/materialRequisition/materialForm.scss";
.search-bottoms {
  width: 100%;
  height: 0.5rem;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0px;
  padding: 0rem 0.11rem;
  box-sizing: border-box;
  font-size: 0.16rem;
  font-weight: 500;
  z-index: 9;
  .btnconfirm {
    flex: 1;
    background: #1890ff;
    box-sizing: border-box;
    height: 0.39rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.03rem;
    color: #ffffff;
  }
}
</style>
